export default function DocumentAddendumController(
  $q,
  $rootScope,
  $scope,

  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  editDocumentAttachmentDialog,
  ssDialogService,
) {
  const vm = this;

  // Set Default Values
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditAddendum = _handleEditAddendum;
  vm.handleDeleteAddendum = _handleDeleteAddendum;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditAddendum($event) {
    ssDialogService.dialogs.pm.editDocumentAttachmentDialog = ssDialogService.alert(
      editDocumentAttachmentDialog.getOptions($event, {
        document: {
          policyDocumentId: vm.policyDocumentId,
        },
        attachment: vm.addendum,
        attachmentType: 'addendum',
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  function _handleDeleteAddendum($event) {
    ssDialogService.dialogs.pm.deleteDocumentAddendumConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Attached Document?',
        message: `Are you sure you want to delete document "${vm.addendum.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.pm.deleteDocumentAddendumConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return pmDataService
      .deleteDocumentAddendum(vm.addendum.policyDocumentAddendaId)
      .then(() => {
        alerts.success('The addendum has been deleted successfully.');
        $rootScope.$broadcast('refreshPMDocumentAttachments', { policyDocumentId: vm.addendum.policyDocumentId });
        _closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the addendum.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.deleteDocumentAddendumConfirmDialog);
  }
}

DocumentAddendumController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'pmDataService',
  'pmSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'editDocumentAttachmentDialog',
  'ssDialogService',
];
